import React from 'react'
import { faClose, FaIcon } from '@/lib/fa'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { TextAreaField } from '@/ui/form/controls/TextAreaField'

type EventsNoteModalProps = {
  event: any
  handleClose: () => void
  noteDraft: string
  setNoteDraft: (value: string) => void
  handleSave: (options?: { deleteNote?: boolean }) => void
}

const EventsNoteModal = ({
  event,
  handleClose,
  noteDraft,
  setNoteDraft,
  handleSave,
}: EventsNoteModalProps) => {
  const { t } = useLocalize()
  return (
    <ModalLayout>
      <div className="tw-relative tw-flex tw-h-fit tw-w-[400px] tw-max-w-[400px] tw-flex-col tw-gap-2 tw-rounded-lg tw-bg-white tw-p-4">
        <div className="tw-z-[90] tw-flex tw-w-full tw-items-center tw-justify-between">
          <div className="tw-flex tw-items-center tw-gap-2">
            <span className="tw-text-base tw-font-semibold tw-text-content-base">
              {event.comments ? t('notes.edit-note') : t('notes.add-note')}
            </span>
          </div>
          <FaIcon
            icon={faClose}
            className="tw-cursor-pointer"
            onClick={() => handleClose()}
          />
        </div>
        <TextAreaField
          value={noteDraft}
          onChange={(e) => setNoteDraft(e.target.value)}
          maxLength={382}
          placeholder={t('notes.note-placeholder')}
          fullWidth
          rows={4}
        />
        <div className="tw-flex tw-items-center tw-justify-between">
          <button
            type="button"
            onClick={() => handleSave({ deleteNote: true })}
            className="tw-cursor-pointer tw-rounded-lg tw-border tw-border-red-500 tw-bg-white tw-p-3 tw-text-sm tw-font-medium tw-text-red-500 hover:tw-opacity-80"
          >
            {t('notes.delete-note')}
          </button>
          <button
            type="button"
            onClick={() => handleSave()}
            className="tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80"
          >
            {t('notes.save-note')}
          </button>
        </div>
      </div>
    </ModalLayout>
  )
}

export default EventsNoteModal
